export const actionTypes = {
    GET_SENSOR_FEATURES: 'sensorProperties/GET_SENSOR_FEATURES',
    GET_SENSOR_PROPERTIES: 'sensorProperties/GET_SENSOR_PROPERTIES',
    GET_SENSOR_GATEWAYINFO: 'sensorProperties/GET_SENSOR_GATEWAYINFO',
    GET_ASSET_INFO: 'sensorProperties/GET_ASSET_INFO',
    GET_GATEWAY_INFO: 'sensorProperties/GET_GATEWAY_INFO',
    CLEAR_STORE: 'sensorProperties/CLEAR_STORE',
    CLEAR_TIMESERIES_STORE: 'sensorProperties/CLEAR_TIMESERIES_STORE',
    GET_ASSET_DETAILS: 'detailedInformation/GET_ASSET_DETAILS',
    GET_SENSOR_TIMESERIES_CONFIG: 'sensorProperties/GET_SENSOR_TIMESERIES_CONFIG',
    GET_SENSOR_TIMESERIES: 'sensorProperties/GET_SENSOR_TIMESERIES',
    GET_SENSOR_RSSI_VALUE: 'sensorProperties/GET_SENSOR_RSSI_VALUE',
    GET_SENSOR_BATTERY_LEVEL: 'sensorProperties/GET_SENSOR_BATTERY_LEVEL',
};

export const ITEMS_PER_PAGE = 15;

export const ITEM_BATTERY_LEVEL = 'BatteryValue';
export const ITEM_RSSI_FEATURE = 'RSSIAvgValue';
export const ITEM_SENSOR_BATTERY_LEVEL = 'SensorBatteryLevel';

export const BATTERY_LEVEL_SUPPORTED_SENSOR_TYPES = ['CoMoHP', 'CoMoSP'];
